/**
 * Monta a query da listagem de Unidade Parceira.
 * O backend normaliza máscara e caixa do CNPJ; a tela só encaminha o que foi digitado.
 *
 * @param {Object} filter
 * @returns {Object}
 */
export const buildUnidadeParceiraQuery = (filter) => {
    const source = filter || {};
    const query = {
        cd: source.cd == null ? "" : source.cd,
        descr: source.descr == null ? "" : source.descr,
        unidade_cnpj: source.unidade_cnpj == null ? "" : source.unidade_cnpj,
        parceiro_cnpj: source.parceiro_cnpj == null ? "" : source.parceiro_cnpj,
    };

    if (source.status && source.status.value != null && source.status.value !== "") {
        query.status = source.status.value;
    }

    return query;
};
